import { SporsmalType, SvarId } from '../../types/generated-types';
import { CurrentSporsmal } from '../reducer/current-steg';
import { Checkboxsporsmal } from '../reducer/sporsmalsflyt-types';

export interface CurrentCheckboxSporsmal {
    type: SporsmalType.Checkbox;
    sporsmal: Checkboxsporsmal;
    alternativer: CurrentCheckboxAlternativ[];
}

export interface CurrentCheckboxAlternativ {
    id: SvarId;
    tekst: string;
    checked: boolean;
}

export interface BesvartCheckboxSporsmal {
    type: SporsmalType.Checkbox;
    sporsmal: Checkboxsporsmal;
    alternativer: CurrentCheckboxAlternativ[];
}

export const isCheckboxSporsmal = (currentSporsmal: CurrentSporsmal): currentSporsmal is CurrentCheckboxSporsmal =>
    currentSporsmal.type === SporsmalType.Checkbox;

export const isBesvartCheckboxSporsmal = (sporsmal: CurrentCheckboxSporsmal): sporsmal is BesvartCheckboxSporsmal => {
    if (sporsmal.alternativer.length === 0) return false;
    return (
        sporsmal.sporsmal.alternativer.findIndex((alternativ) =>
            sporsmal.alternativer.find(
                (currentAlternativSvarId) =>
                    currentAlternativSvarId.checked && alternativ.id === currentAlternativSvarId.id,
            ),
        ) >= 0
    );
};

export const formatChosenCheckboxAlternativesForOppsummerng = (
    chosenAlternativer: CurrentCheckboxAlternativ[],
): string => {
    return chosenAlternativer
        .filter((alternativ) => alternativ.checked)
        .map((chosen) => chosen.tekst)
        .join(', ');
};
